import { render, staticRenderFns } from "./Indexnew.vue?vue&type=template&id=2a5a864c&scoped=true&"
import script from "./Indexnew.vue?vue&type=script&lang=js&"
export * from "./Indexnew.vue?vue&type=script&lang=js&"
import style0 from "./Indexnew.vue?vue&type=style&index=0&id=2a5a864c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5a864c",
  null
  
)

export default component.exports